/**
 * @function setCookie set new cookie
 * @param {string} cName   cookie name
 * @param {string} cValue  cookie value
 * @param {string} expDays amount of days to expire
 */
export default function setCookie( cName, cValue, expDays ) {
  const date = new Date();
  date.setTime( date.getTime() + ( expDays * 24 * 60 * 60 * 1000 ) );
  const expires = 'expires=' + date.toUTCString();
  document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
}
